import axios from "axios";
import { Constants, CookieService, Utils } from "../../../shared";

export const RatesAndFeesService = {
  /**
   * Retrieves rate and fee information for a given advertisement type.
   * @param {string} adType - The type of advertisement for which you want to fetch rate and fee information.
   * @returns {Promise<any>} A Promise that resolves with the rate and fee data or rejects with an error.
   * @throws {Error} If the provided adType is invalid or if there's an issue with the request.
   */
  getRatesAndFees: (adType) => {
    let clientId = Utils.getRouteParam("clientid");
    const requestUrl =
      Constants.ClientDataUrl + "/" + clientId + "/ratesandfees?type=" + adType;
    return axios
      .get(requestUrl, {
        headers: {
          ansid: CookieService.getCookie("ANsid"),
          clientid: clientId,
        },
      })
      .then(
        (response) => {
          return response && response.data;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
  },

  getRatesAndFeesDropdowns: () => {
    let clientId = Utils.getRouteParam("clientid");
    const requestUrl = Constants.enumerationsUrl
    return axios.get(requestUrl, {
        headers: {
          ansid: CookieService.getCookie("ANsid"),
          clientid: clientId,
        },
      })
      .then((response) => {
          return response && response.data;
        },(error) => {
          return Promise.reject(error);
        }
      );
  },

  /**
   * Imports rate and fee information for a specific client.
   * @param {Object} payload - The data payload to be sent in the POST request for importing rate and fee information.
   * @returns {Promise<any>} A Promise that resolves with the response data from the server or rejects with an error.
   * @throws {Error} If there's an issue with the request or if the payload is missing required fields.
   */
  createRatesAndFees: (payload) => {
    let clientId = Utils.getRouteParam("clientid");
    return axios
      .post(
        Constants.ClientDataUrl + "/" + clientId + "/ratesandfees",
        payload,
        {
          headers: {
            ansid: CookieService.getCookie("ANsid"),
            clientid: Utils.getRouteParam("clientid")
          },
        }
      )
      .then(
        (response) => {
          return response;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
  },

  updateRatesAndFees: (payload) => {
    let clientId = Utils.getRouteParam("clientid");
    return axios
      .put(
        Constants.ClientDataUrl + "/" + clientId + "/ratesandfees",
        payload,
        {
          headers: {
            ansid: CookieService.getCookie("ANsid"),
          },
        }
      )
      .then(
        (response) => {
          return response;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
  },

  /**
   * Delete rate and fee information for a specific client.
   * @param {string} rateFeesId - The id of the rate and fee information to be deleted.
   * @returns {Promise<any>} A Promise that resolves with the response data from the server or rejects with an error.
   * @throws {Error} If there's an issue with the request or if the payload is missing required fields.
   */
  deleteRatesAndFees: (rateFeesId) => {
    let clientId = Utils.getRouteParam("clientid");
    return axios
      .delete(
        Constants.ClientDataUrl +
          "/" +
          clientId +
          "/ratesandfees" +
          "?ratesfees_detail_id=" +
          rateFeesId,
        {
          headers: {
            ansid: CookieService.getCookie("ANsid"),
            clientid: Utils.getRouteParam("clientid")
          },
        }
      )
      .then(
        (response) => {
          return response;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
  },
};
